export const filterData = {
  // There is No way to fetch all the categories/topics data from Contentful - it's a checkbox field which return an array of Strings specific to a given course
  // we can access label_options with primary tag value
  // i.e. categories[primaryTag].label_options
  // remember to add new label options in Contentful as well
  categories: {
    all: {
      label: "All Categories",
      value: "all",
      label_options: [
        { value: "all", label: "All Levels" },
        { value: "beginner", label: "Beginner" },
        { value: "intermediate", label: "Intermediate" },
        { value: "advanced", label: "Advanced" },
      ],
    },
    development: {
      label: "Development",
      value: "development",
      label_options: [
        { value: "all", label: "All Topics" },
        { value: "web_development", label: "Web Development" },
        { value: "frontend_development", label: "Frontend Development" },
        { value: "backend_development", label: "Backend Development" },
        { value: "software_engineering", label: "Software Engineering" },
        { value: "interview_skills", label: "Interview Skills" },
        { value: "databases", label: "Databases" },
        { value: "mobile_development", label: "Mobile Development" },
        { value: "freelancing", label: "Entrepreneurship & Freelance" },
        { value: "game_development", label: "Game Development" },
        { value: "programming_languages", label: "Programming Languages" },
      ],
    },
    data_and_machine_learning: {
      label: "A.I. & Machine Learning",
      value: "data_and_machine_learning",
      label_options: [
        { value: "all", label: "All Topics" },

        {
          value: "machine_learning_ai_tools",
          label: "Machine Learning & A.I. Tools",
        },
        { value: "generative_ai", label: "Generative A.I." },
        {
          value: "data_science_analysis",
          label: "Data Science & Analysis",
        },
      ],
    },
    build_with_ai: {
      label: "Build with A.I.",
      value: "build_with_ai",
      label_options: [{ value: "all", label: "All Topics" }],
    },
    cyber_security: {
      label: "Cyber Security",
      value: "cyber_security",
      label_options: [
        { value: "all", label: "All Topics" },
        { value: "hacking_cyber_security", label: "Hacking & Cyber Security" },
        { value: "networks_security", label: "Networks & Security" },
        { value: "it_certifications", label: "IT Certifications" },
      ],
    },
    design: {
      label: "Design",
      value: "design",
      label_options: [
        { value: "all", label: "All Topics" },
        { value: "ux_ui", label: "UX & UI" },
        { value: "game_design", label: "Game Design" },
        { value: "nfts", label: "NFTs" },
      ],
    },
    cloud_and_devops: {
      label: "Cloud & DevOps",
      value: "cloud_and_devops",
      label_options: [
        { value: "all", label: "All Topics" },
        { value: "devops", label: "DevOps" },
        { value: "aws", label: "AWS" },
        {
          value: "cloud_architecture_design",
          label: "Cloud Architecture & Design",
        },
      ],
    },

    web3: {
      label: "Web3 & Blockchain",
      value: "web3",
      label_options: [
        { value: "all", label: "All Topics" },
        {
          value: "ethereum",
          label: "Ethereum",
        },
      ],
    },
    business: {
      label: "Business & Data",
      value: "business",
      label_options: [
        { value: "all", label: "All Topics" },
        {
          value: "data_analysis_business_intelligence",
          label: "Data Analysis & Business Intelligence",
        },
        { value: "freelancing", label: "Entrepreneurship & Freelance" },
        { value: "seo", label: "SEO" },
        { value: "office_applications", label: "Office Applications" },
      ],
    },
    life_skills: {
      label: "Life Skills",
      value: "life_skills",
      label_options: [{ value: "all", label: "All skills" }],
    },
  },

  sortByLabelledOptions: [
    { value: "most_popular", label: "Most Popular" },
    { value: "most_recent", label: "Most Recent" },
  ],



  // we need to validate param e.g. ztm.io?category=coding
  validParamValues: [
    "all",
    "development",
    "ai_machine_learning",
    "build_with_ai",
    "cyber_security",
    "design",
    "cloud_devops",
    "web3_blockchain",
    "web3",
    "business_data",
    "life_skills",
    "beginner",
    "intermediate",
    "advanced",
    "bootcamp",
    "byte",
    "project",
    "most_recent",
    "most_popular",
    "web_development",
    "frontend_development",
    "backend_development",
    "software_engineering",
    "interview_skills",
    "databases",
    "mobile_development",
    "freelancing",
    "game_development",
    "programming_languages",
    "machine_learning_ai_tools",
    "generative_ai",
    "data_science_analysis",
    "hacking_cyber_security",
    "networks_security",
    "it_certifications",
    "ux_ui",
    "game_design",
    "nfts",
    "devops",
    "aws",
    "cloud_architecture_design",
    "ethereum",
    "data_analysis_business_intelligence",
    "entrepreneurship_freelance",
    "seo",
    "office_applications",
  ],
}
